import {copyToClipboard} from '../utilities/helpers';
import {toggleToastsVisibility} from '../utilities/domGeneralManipulation';

export default () => {
    document.body.addEventListener('click', (e) => {
        const {target} = e;

        if (!target.classList.contains('copy')) {
            return;
        }

        e.preventDefault();

        const copyWrapper = target.closest('.copyContainer')?.querySelector('.copyContainer__content');
        const text = copyWrapper.textContent || copyWrapper.innerText
        const copied = copyToClipboard(text);

        if(!copied) {
            return;
        }

        toggleToastsVisibility('copyToast');
    });
}
